<!-- eslint-disable vue/no-template-shadow -->
<template>
    <div class="flow">
        <div class="flow-id-number">{{ index + 1 }}</div>

        <div class="flow-container">
            <form class="flow-wrapper ui-table scroll-color">
                <table class="flow-table">
                    <thead>
                        <tr class="pl5-2">
                            <th width="20">&nbsp;</th>
                            <th width="140">Parcela</th>
                            <th width="120" v-if="form?.data?.simulationType !== 'vertical'">Taxa</th>
                            <th width="150">Quantidade</th>
                            <th width="110">Vencimento</th>
                            <th width="120">Porcentagem</th>
                            <th width="200">Valor</th>
                            <th width="150" v-if="$mx_userIsAdmin">Reajuste</th>
                            <th width="40">
                                <button class="button-close" type="button" @click="removeFlowConfirm()" data-ui="sales-table-button-remove-flow">
                                    <i class="fal fa-times"/>
                                </button>
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        <ui-sales-table-item
                            v-for="(item, index) in data.sales_table_item"
                            :key="item.id"
                            :data="item"
                            :form="form"
                            :flow="data"
                            :unity="unity"
                            :index="index"
                            :input-fixed="inputFixed"
							:simulation-type="form?.data?.simulationType"
                            @remove="removeItemHandler"
                            @change="changeItemHandler"
                            @input-fixed="fixedValueHandler" />
                    </tbody>
                </table>
            </form>

            <div class="flow-details">
                <div class="details">
                    <div class="calc">
                        <span>Saldo Calculado:</span>
                        <strong data-ui="sales-strong-table-total-cost">{{ totalCostComputed | currencyBRL }}</strong>
                    </div>
                    <!-- <div class="badge warning success error"></div> -->
                    <div class="badge" :class="totalPercentComputed >= 100 ? 'success' : 'error'">
                        Porcentagem Calculada:
                        <strong data-ui="sales-strong-table-total-percentage">
                            {{ `${totalPercentFormattedComputed}%` }}
                        </strong>
                    </div>
                </div>
                <div class="buttons">
                    <ui-button v-if="updated" design="success md" @click="submit()" :disabled="saveFlowLoading" :data-ui="'sales-table-button-save-flow'">
						<span v-if="saveFlowLoading">
							<ui-load-indicator v-if="saveTableLoad" bg-color="#e7e9f4" color="#69D296" :h="16" :stroke="8" />
							<span>Salvando...</span>
						</span>
						<span v-else>Salvar alterações</span>
					</ui-button>
                    <ui-button design="primary md" @click="addEmptyItem(data)" :data-ui="'sales-table-button-add-parcel'" :disabled="saveFlowLoading">Adicionar parcela</ui-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import { uiLoadIndicator } from '@/components/ui'
	import { uiButton } from '@/components/ui/buttons'
	import { currencyBRL } from '@/filters'
	import uiSalesTableItem from '../sales-table-item'
    import {  permissionsMixin } from '@/mixins'

	const defaultFormItemData = (data) => {
		return {
			id: 'random-' + Math.floor(Math.random() * Date.now() + 1),
			name: '',
			percent: '',
			parcel_type: null,
			interest: 'without',
			quota: '',
			data: null,
            fixed_value:0,
			due_date: 0,
			type_readjust: null,
			sales_table_flow_id: data.id,
			deleted_at: null,
			pmt: '',
		}
	}

	export default {
		name: 'ui-sales-table-flow',
		components: {
			uiButton,
			uiSalesTableItem,
		},
		mixins: [ permissionsMixin ],

		filters: {
			currencyBRL,
		},

		props: {
			data: {
				type: Object,
				required: true,
			},
			form: {
				type: Object,
				required: true,
			},
			index: {
				type: Number,
				required: true,
			},
			// eslint-disable-next-line vue/require-prop-types
			unity: {
				required: true,
			},
		},

		data() {
			return {
				saveTableLoad: false,
				saveFlowLoading: false,
				updated: false,
				inputFixed: null,
			}
		},

		computed: {
			/**
			 * Computed proprety para calcular o percentual resultante do cadastro
			 * das parcelas
			 */
			totalCostComputed() {
				let total = 0
				if (this.unity && this.data.sales_table_item.length) {
					/** Calcula-se o valor da unidade levando em consideração as parcelas/séries do tipo Valor Fixo */
					var unityValue = parseFloat(this.unity.cost)
					if(this.form.data.simulationType == 'horizontal') unityValue -= this.getFixedValue()

					if(this.form.data.simulationType === 'horizontal'){
						for (const item of this.data.sales_table_item) {
						switch (item.parcel_type) {
							/** Parcelas/séries do tipo Valor Fixo são inseridas diretamente no saldo calculado */
							case 'fixed_value':
								total += parseFloat(item.pmt) * item.quota
								break

							default:
								if(item.pmt){
									total += (parseFloat(item.percent) * unityValue) / 100 || 0
								}
								break
						}
					}
					}

					if(this.form.data.simulationType == 'vertical') {
						for (const item of this.data.sales_table_item) {
							total += parseFloat(item.pmt * item.quota) || 0
						}
					}
					
				}
				return total
			},
			/**
			 * Computed property para calcular o saldo resultante do cadastro das
			 * parcelas
			 */
			totalPercentComputed() {
				let total = 0
				if (this.data.sales_table_item.length && this.form.data?.simulationType === 'horizontal') {
					for (const item of this.data.sales_table_item) {
						if (item.parcel_type !== 'fixed_value'){
							total += parseFloat(item.percent) || 0
						}
					}
				}
				/** Caso o fluxo seja do tipo vertical, o percentual total é calculado somando-se os valores das parcelas */
				if(this.data.sales_table_item.length && this.form.data?.simulationType === 'vertical') {
					for (const item of this.data.sales_table_item) {
						total += parseFloat(item.pmt * item.quota) || 0
					}
					
					if(!this.unity?.cost) return total = 0;
					if (this.unity?.cost) total = (total / this.unity.cost) * 100

				}
				
				return total.toFixed(2)
			},
			/**
			 * Computed property para formatar as casas decimais do percentual total calculado
			 * para o fluxo
			 */
			totalPercentFormattedComputed() {
				return Number(this.totalPercentComputed).toFixed(2).replace('.', ',');
			},
		},

		created() {
			/**
			 * Exclui o fluxo
			 * Ouve o evento que vem do modal de confirmação
			 */
			this.$root.$on('modal-msg-event-delete-sales-table-flow', (payload) => {
				if (payload.action && payload.data === this.index) this.removeFlow()
			})

			/** Esconde o botão de salvar o fluxo quando este já foi submitado */
			this.$root.$on('event-submited-flow', (payload) => {
				if (this.data.position === payload) this.updated = false
			})
			this.$root.$on('flow-submit', (payload) => {
				this.saveFlowLoading = payload
			})
		},
		methods: {
			/**
			 * Adiciona uma nova regra/série no fluxo selecionado do formulário
			 */
			addEmptyItem() {
				this.$set(this.data, 'sales_table_item', [
					...this.data.sales_table_item,
					defaultFormItemData(this.data),
				])
			},
			/**
			 * Calcula o valor fixo de acordo com as parcelas/séries do tipo Valor Fixo
			 */
			getFixedValue() {
				let value = 0
				for (const item of this.data.sales_table_item) {
					if (item.parcel_type === 'fixed_value'){
						value += parseFloat(item.pmt) * item.quota || 0
					}
				}
				return value
			},
			/**
			 * Remove uma série/parcela de acordo com o index
			 */
			removeFlowConfirm() {
				this.$root.$emit('modal-msg-open-delete-sales-table-flow', this.index)
			},
			/**
			 * Remove uma série/parcela de acordo com o index
			 */
			removeFlow() {
				this.$emit('remove', this.index)
			},
			/**
			 * Remove uma série/parcela de acordo com o index
			 */
			removeItemHandler(index) {
				const item = this.data.sales_table_item[index]
				this.$delete(this.data.sales_table_item, index)

				/** Caso o item removido já tivesse sido instanciado, atualiza-se o nome do fluxo */
				if (item && item.id && !String(item.id).includes('random')) {
					// eslint-disable-next-line vue/no-mutating-props
					this.data.name = Object.values(this.data.sales_table_item)
						.map((item) => item.quota + 'x' + item.name)
						.join(' + ')
				}

				/** Caso todos os itens tenham sido removidos, apaga-se o fluxo */
				if (this.data.sales_table_item && !this.data.sales_table_item.length) this.$emit('remove', this.index)
			},
			/**
			 * Intercepta a mudança em uma série/parcela do fluxo
			 */
			changeItemHandler() {
				this.updated = true
				this.$emit('update', { index: this.index, data: this.data })
			},
			/**
			 * Intercepta a inserção de uma série do tipo Valor Fixo e então sinaliza
			 * para as outras séries recalcularem seus valores
			 */
			fixedValueHandler(params) {
				this.inputFixed = { ...params }
			},
			/**
			 * Submita os dados dos fluxos cadastrados
			 */
			submit() {
				this.$emit('submit')
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
